$.jqm.focusFunc = function () { };



// WEBPACK FOOTER //
// ./vendor/jqmodal-fix/index.js